export default "__VITE_ASSET__db1c7249__$_?component__"